export const locale = {
    lang: 'en',
    data: {
        ALL_CARDS: 'All cards',
        LIST_CARDS: 'Cards from lists',
        CATEGORIES: 'Colors',
        TYPE: 'Type',
        POINTS: 'Votes',
        CARDS_HAVE: 'Cards that have',
        OF: 'than',
        CHOOSE_CARDS: 'Choose cards',
        PLUS: 'more',
        MOINS: 'less',
        SAVE: 'Save',
        CANCEL: 'Cancel',
        NEXT: 'Next'
    }
};
